// extracted by mini-css-extract-plugin
export var numpadContainer = "_p9-1";
export var phoneButton = "_p9-0";